import * as React from 'react';
import { useState } from 'react';
import { ChartInterval } from '../../trader/PositionDetailChart';
import { Box, HStack } from '@chakra-ui/react';
import { ThemedText } from '@/components/ui/ThemedText';

// import type { ChartInterval } from '@/stores/user'

interface ChartIntervalPickerProps {
  interval?: ChartInterval;
  onIntervalChange?: (interval: ChartInterval) => void;
}

const intervals: Array<{ value: ChartInterval; label: string }> = [
  { value: '1m', label: '1m' },
  { value: '5m', label: '5m' },
  { value: '15m', label: '15m' },
  { value: '1h', label: '1h' },
  { value: '4h', label: '4h' },
  { value: '1d', label: '1d' },
  { value: '1w', label: '1w' },
];
const ChartIntervalPicker: React.FC<ChartIntervalPickerProps> = ({
  interval: propInterval,
  onIntervalChange,
}) => {
  // 使用useState管理图表间隔状态，优先使用传入的props
  const [chartInterval, setChartInterval] = useState<ChartInterval>(
    propInterval || '1m',
  );

  // 当props变化时更新本地状态
  React.useEffect(() => {
    if (propInterval) {
      setChartInterval(propInterval);
    }
  }, [propInterval]);

  return (
    <HStack gap={1} p={1} pt={0}>
      {intervals.map((interval) => (
        <Box
          key={interval.value}
          flex={1}
          px={3}
          py={2}
          pt={0}
          onClick={() => {
            setChartInterval(interval.value);
            onIntervalChange?.(interval.value);
          }}
          cursor="pointer"
        >
          <ThemedText
            fontSize="xs"
            fontWeight="medium"
            textAlign="center"
            color={
              chartInterval === interval.value ? 'text.t1/90' : 'text.t1/60'
            }
          >
            {interval.label}
          </ThemedText>
        </Box>
      ))}
    </HStack>
  );
};

export default ChartIntervalPicker;
